import { render, staticRenderFns } from "./DetailProperties.vue?vue&type=template&id=43d91062&scoped=true&"
import script from "./DetailProperties.vue?vue&type=script&lang=js&"
export * from "./DetailProperties.vue?vue&type=script&lang=js&"
import style0 from "./DetailProperties.vue?vue&type=style&index=0&id=43d91062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d91062",
  null
  
)

export default component.exports